import { objectToUrlParams } from 'utils/params';
import BaseResource from './BaseResource';
import ReconciliationResource from './ReconciliationResource';

export default class ReconciliationsResource extends BaseResource {
  constructor() {
    super({ url: '/api/reconciliations' });
  }

  list(params = {}) {
    const urlParams = objectToUrlParams(params);
    return super
      .get({ url: `${this.url}${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  statusCount(params = {}) {
    const urlParams = objectToUrlParams(params);
    return super
      .get({ url: `${this.url}/status${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  reconciliation(id) {
    return new ReconciliationResource(`${this.url}/${id}`);
  }
}
